import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  Grid,
  DialogActions,
  TextField,
  Typography,
  Button,
} from "@material-ui/core";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import { getWeekDates } from "../../GlobalFunctions";
import ButtonDownload from "../ButtonDownload";
import AssignBranchInputComponent from "./AssignBranchInputComponent";
const axios = require("axios");

const Approve = (props) => {
  const { truckId, itemData, week, day, itemId, ...otherProps } = props;
  const { createHourlyModel } = useContext(HourlyDataContext);
  const hourlyModel = createHourlyModel({ week, day });
  const [branchObjArray, setBranchObjArray] = useState([]);
  const { userData, setUserData } = useContext(UserDataContext);
  const fetchedColumns = ["startTimeString", "endTimeString", "hourlyRate"];
  const calculatedColumns = ["totalHours", "totalCharge"];
  const commentColumns = ["driverComments", "adminComments"];
  const [loading, setLoading] = useState(false);

  const editHourly = async () => {
    const newData = {
      ...itemData,
      changedRateAssignedBranches: branchObjArray,
    };

    const requestChange = {
      method: "POST",
      url: `rates/change/`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: newData,
    };
    const { startDate, endDate } = getWeekDates(week);
    const requestStatus = {
      method: "GET",
      url: `/invoices/getState/${truckId}/${startDate.toISOString()}/${endDate.toISOString()}/${week}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
    };

    try {
      setLoading(true);
      await axios(requestChange);

      const res = await axios(requestStatus);
      let invoiceStatuses = userData.invoiceStatuses;
      invoiceStatuses[truckId][week] = res.data.invoiceState;
      setUserData({ ...userData, invoiceStatuses });
    } catch {}
  };

  return (
    <Dialog {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Approve Hourly</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid
          container
          direction="column"
          justify="flex-start"
          alignItems="stretch"
          spacing={1}
        >
          {fetchedColumns.map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>{hourlyModel[col].displayName}:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={itemData[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    {...hourlyModel[col].textFieldProps}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
          {calculatedColumns.map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>{hourlyModel[col].displayName}:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={hourlyModel[col].displayValue(itemData)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}

          {commentColumns.map((col) => (
            <Grid item key={col}>
              <Grid container>
                <Grid item xs={3}>
                  <Typography>{hourlyModel[col].displayName}:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={itemData[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    {...hourlyModel[col].textFieldProps}
                  />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Divider />
      <DialogContent>
        <AssignBranchInputComponent
          week={week}
          value={branchObjArray}
          setValue={setBranchObjArray}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <ButtonDownload variant="contained" color="primary" itemId={itemId} />
        <Button
          disabled={
            loading ||
            !hourlyModel.changedRateAssignedBranches.validate({
              ...itemData,
              changedRateAssignedBranches: branchObjArray,
            })
          }
          onClick={() => editHourly()}
          variant="contained"
          color="primary"
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Approve;

Approve.propTypes = {
  truckId: PropTypes.number.isRequired,
  week: PropTypes.number.isRequired,
  day: PropTypes.number.isRequired,
  itemId: PropTypes.string.isRequired,
  itemData: PropTypes.object.isRequired,
};
